import axiosClient from "../axiosClient";

export const manageNotification = {
    getListService: (param) => {
        return axiosClient.get("notificationColor/get-list-notification-color/")
    },
    getListNotificationType: (param) => {
        return axiosClient.get("notificationType/get-list-notification-type/", {
            params: param
        })
    },
    getListNotificationMethod: (param) => {
        return axiosClient.get("notificationMethod/get-list-notification-method/", {
            params: param
        })
    },
    getListNotificationLevel: (param) => {
        return axiosClient.get("notificationLevel/get-list-notification-level/", {
            params: param
        })
    },
    getListCameraNotification: (param) => {
        return axiosClient.get("cameraNotification/get-list-camera-notification/", {
            params: param
        })
    },
    getListCameraNotificationDefault: () => {
        return axiosClient.get("cameraNotification/get-list-camera-notification-default/")
    },
    postAddNotificationColor: (data) => {
        return axiosClient.post("notificationColor/post-add-notification-color/", data)
    },
    postAddCameraNotification: (data) => {
        return axiosClient.post("cameraNotification/post-add-camera-notification/", data)
    },
    postAddNotificationColorDefault: (data) => {
        return axiosClient.post("notificationColor/post-add-notification-color-default/", data)
    },
    postAddNotificationValueDefault: (data) => {
        return axiosClient.post("cameraNotification/post-add-camera-notification-default/", data)
    },
    // Chanel
    getListNotificationChanel: (param) => {
        return axiosClient.get("notificationChannel/get-list-notification-channel/", {
            params: param
        })
    },
    getStateConnectTelegram: () => {
        return axiosClient.get("notificationChannel/get-state-connect-telegram/")
    },
    postRegisterTelegramNotification: (data) => {
        return axiosClient.post("notificationChannel/post-register-telegram-notification/", data)
    },
    postTestConnectTelegramNotification: (data) => {
        return axiosClient.post("notificationChannel/post-test-connect-telegram-notification/", data)
    },
    postUpdateConnectTelegramNotification: (data) => {
        return axiosClient.post("notificationChannel/post-update-connect-telegram-notification/", data)
    },
    postAddNotificationChannel: (data) => {
        return axiosClient.post("notificationChannel/post-add-notification-channel/", data)
    },
    putChangeChanel: (id, data) => {
        return axiosClient.put("notificationChannel/put-change-info-notification-channel/", data, {
            params: {
                notification_channel_code: id
            }
        })
    },
    deleteRemoveNotificationChannel: (id) => {
        return axiosClient.delete("notificationChannel/delete-remove-notification-channel/", {
            params: {
                notification_channel_code: id
            }
        })
    },
    putChangeStatusNotification: (id, data) => {
        return axiosClient.put(`cameraNotification/put-change-status-notification/`, data, {
            params: {
                code: id
            }
        })
    },
    // sound
    getListNotificationSound: () => {
        return axiosClient.get(`notificationSound/get-list-notification-sound/`)
    }
}